import React from "react"
import styles from "./styles.scss"
import InfoItem from "components/InfoItem"
import Quote from "./Quote"
import { CaseStudyContext } from ".."

class CompanyInformation extends React.Component {
  render() {
    return (
      <CaseStudyContext.Consumer>
        {caseStudy => {
          let renderCompanyLogo = this.props.renderCompanyLogo

          if (!renderCompanyLogo) {
            renderCompanyLogo = () => (
              <img
                className={styles.logo}
                src={caseStudy.companyLogo}
                alt={`${caseStudy.company} logo`}
              />
            )
          }

          return (
            <section className={styles.container}>
              <div className={styles.wrapper}>
                <div className={styles.info}>
                  <div>
                    {caseStudy.replaceLogoWithString ? (
                      <span className={styles.textLogo}>
                        {caseStudy.projectLogo}
                      </span>
                    ) : (
                      renderCompanyLogo()
                    )}
                  </div>
                  <InfoItem title="Företagstyp" icon={["fas", "building"]}>
                    {caseStudy.companyType}
                  </InfoItem>
                  <InfoItem title="Plats" icon={["fas", "map-marker-alt"]}>
                    {caseStudy.companyLocation}
                  </InfoItem>
                  <InfoItem
                    title="Mål för projektet"
                    icon={["fas", "bullseye"]}
                  >
                    {caseStudy.projectGoal}
                  </InfoItem>
                  <InfoItem title="Tekniker" icon={["fas", "toolbox"]}>
                    {caseStudy.tools}
                  </InfoItem>
                  {caseStudy.websiteUrl && (
                    <InfoItem title="Hemsida" icon={["far", "globe"]}>
                      <a
                        href={caseStudy.websiteUrl}
                        target="_blank"
                        title={`Gå till ${caseStudy.websiteUrl}`}
                        rel="noopener noreferrer"
                      >
                        {caseStudy.websiteString}
                      </a>
                    </InfoItem>
                  )}
                </div>
                <div className={styles.textContainer}>
                  <h3 className={styles.summaryTitle}>Sammanfattning</h3>
                  {this.props.renderSummary()}
                  {caseStudy.quote && (
                    <Quote
                      author={caseStudy.quoteAuthor}
                      authorPosition={caseStudy.quoteAuthorPosition}
                      image={caseStudy.quoteImage}
                    >
                      {caseStudy.quote}
                    </Quote>
                  )}
                </div>
              </div>
            </section>
          )
        }}
      </CaseStudyContext.Consumer>
    )
  }
}

export default CompanyInformation



// WEBPACK FOOTER //
// ./src/components/CaseStudy/CompanyInformation/index.jsx